import { Card } from '@/components/ui/card';
import { OctagonX } from 'lucide-react';

const NoData = () => {
  return (
    <>
      <Card className="mx-auto mb-4 p-8 text-center transition-all hover:border-blue-200 md:mb-6">
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="rounded-full bg-gray-100 p-4">
            <OctagonX className="size-8 text-gray-400" />
          </div>
          <div className="text-lg font-medium text-gray-600">
            No transactions found
          </div>
          <p className="text-sm text-gray-500">
            This gift card has not been used for any transactions yet.
          </p>
        </div>
      </Card>
    </>
  );
};

export default NoData;
